import { z } from 'zod';
import { mutation, noBody } from '../../utils';
export const unregisterFromTradingCompetition = mutation({
    method: 'DELETE',
    path: '/:tradingCompetitionId/register',
    body: noBody(),
    responses: {
        200: z.object({
            success: z.boolean(),
        }),
    },
});
